var _g, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle3, _circle4, _path1, _path10, _path11, _circle5, _circle6, _path12, _circle7, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBat100(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 126,
    viewBox: "0 0 191 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_49919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.08 4.09931C48.0389 1.47557 51.5799 0.599273 54.08 0.0993072C56.5801 -0.400659 63.5799 1.09925 65.58 2.09931C67.5801 3.09936 69.0791 10.0994 74.0791 11.5994C79.0791 13.0994 169.578 10.5994 172.579 10.5994C175.58 10.5994 180.079 14.7799 180.079 18.0994V28.5994C180.079 32.5994 180.079 35.5993 177.079 37.0994C172.579 39.3494 172.731 40.1721 171.079 42.0994C169.427 44.0267 169.477 44.6335 170.08 47.0993C170.98 50.7822 173.543 52.2816 176.079 55.0994C180.58 60.0994 181.745 61.1722 183.579 66.0994C185.844 72.1823 186.556 76.1086 186.579 82.5994C186.603 89.284 185.513 92.5923 182.58 98.5994C179.244 105.434 174.749 109.444 168.08 113.099C163.53 115.593 160.267 115.599 155.079 115.599C147.079 115.599 143.613 115.18 136.08 113.099C130.96 111.685 128.237 110.371 123.08 109.099C111.079 106.139 78.7144 107.493 72.0791 108.599C69.0791 109.099 61.0791 112.109 56.5791 114.099C51.2219 116.469 46.0791 117.599 40.0791 117.599C34.1501 117.599 29.0791 116.099 26.5791 115.099C24.0791 114.099 17.5791 110.099 16.0791 108.599C14.5791 107.099 9.14743 100.63 7.07997 94.5993C4.89373 88.2221 3.66514 84.328 4.07997 77.5993C4.53592 70.2037 5.78553 65.6376 10.08 59.5993C13.5293 54.7493 16.4043 52.5374 21.58 49.5993C28.5814 45.6249 37.5791 46.5994 41.58 44.5993C45.6723 42.5536 47.1217 39.7342 49.08 35.5993C51.3612 30.7826 52.8373 24.833 51.08 22.0993L46.58 15.0993C43.306 10.7823 42.121 6.72304 45.08 4.09931Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.99 27.1144C129.586 29.537 124.717 30.9656 119.694 28.7295C110.467 27.008 103.543 24.8936 103.341 23.8842C103.139 22.8747 105.965 22.6729 105.965 22.6729H111.012L120.299 22.8747L126.154 22.6729C129.062 23.4717 130.394 24.6917 129.99 27.1144Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3626 82.8356L44.3909 79.8073L52.8701 56.9941L48.0248 55.7828L49.438 50.5337C49.438 50.5337 50.6494 46.2943 50.2456 45.4866C49.8418 44.6789 46.3101 50.6849 44.3909 58.0035L46.6116 59.6186L39.5456 81.2204L41.3626 82.8356Z",
    fill: "#003E60",
    stroke: "#003E60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7056 43.0635L57.4307 40.6358L55.0905 39.9834L54.4849 41.0446L52.2641 42.8616L49.6396 52.5521L51.6585 53.5616L53.6773 46.6974L55.0905 46.0918L56.7056 43.0635Z",
    fill: "#797979",
    stroke: "#797979"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 4.23019,
    transform: "matrix(-1 0 0 1 44.5928 77.5864)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.283,
    cy: 30.283,
    r: 28.783,
    transform: "matrix(-1 0 0 1 71.6455 50.5337)",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6402 57.1959L33.2873 105.043M68.2137 88.8921L14.9157 72.5393M25.6156 59.6185L58.927 103.832M65.3873 68.5015L16.5307 93.5355M36.5175 55.3789L46.8138 106.86M59.3307 60.0223L23.193 102.015M14.5119 83.2393L69.627 77.9902",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.426 53.5614L120.299 56.3878L121.309 52.552C121.667 51.6625 121.665 51.2105 121.107 50.5331L118.28 49.3218C116.32 49.0574 115.318 49.1813 113.637 49.7255L112.426 53.5614Z",
    fill: "black",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.714 25.3035L61.6712 25.9559C61.6712 25.9559 64.1268 22.4225 63.7715 19.8463C63.6487 18.9558 63.478 18.4685 63.1658 17.6255C61.8859 14.1687 54.0071 12.8348 56.9074 10.5595C57.269 10.2757 57.6324 10.3151 57.9168 9.95384C58.7167 8.93782 56.7056 7.32942 55.898 6.72376C55.0904 6.1181 53.0788 4.43606 52.6677 5.71422C52.4157 6.49783 53.5572 6.96044 53.2734 7.73309C53.1375 8.10312 52.8712 8.20301 52.6677 8.54064C51.9251 9.77287 51.3357 10.9327 52.0621 12.1746C52.581 13.0619 53.4278 13.0172 54.2828 13.5878C55.7389 14.5595 56.667 14.9865 57.9168 16.2123C59.3694 17.6371 60.6219 18.4431 60.9451 20.452C61.2738 22.4952 59.714 25.3035 59.714 25.3035Z",
    fill: "#797979",
    stroke: "#797979"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.619 46.8995L113.839 47.5052L119.492 28.7297L117.069 28.3259L111.619 46.8995Z",
    fill: "#003E60"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.013 46.8995L114.243 47.707L112.022 53.7636L120.3 56.5901L119.896 58.2052L152.803 77.7882L154.822 80.8165L151.794 80.6146L119.088 60.8297L111.215 86.2674L113.839 86.8731L114.647 84.6523L150.381 81.2202V84.0466L117.877 87.4787L116.868 87.8825L116.262 95.3523L101.928 91.9202L100.919 88.8919L81.3355 71.5297L70.2317 55.3787L60.3393 38.2184L59.128 37.6127L58.1185 40.641L54.6865 39.2278L58.7242 25.4995L62.3581 26.7108V28.7297C71.7545 49.3692 76.8285 58.0072 85.3732 66.0787C92.5867 69.1193 96.7212 70.0375 104.351 69.5108L111.013 46.8995Z",
    fill: "#003E60"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.619 46.8995L113.839 47.5052L119.492 28.7297L117.069 28.3259L111.619 46.8995Z",
    stroke: "#003E60"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M111.013 46.8995L114.243 47.707L112.022 53.7636L120.3 56.5901L119.896 58.2052L152.803 77.7882L154.822 80.8165L151.794 80.6146L119.088 60.8297L111.215 86.2674L113.839 86.8731L114.647 84.6523L150.381 81.2202V84.0466L117.877 87.4787L116.868 87.8825L116.262 95.3523L101.928 91.9202L100.919 88.8919L81.3355 71.5297L70.2317 55.3787L60.3393 38.2184L59.128 37.6127L58.1185 40.641L54.6865 39.2278L58.7242 25.4995L62.3581 26.7108V28.7297C71.7545 49.3692 76.8285 58.0072 85.3732 66.0787C92.5867 69.1193 96.7212 70.0375 104.351 69.5108L111.013 46.8995Z",
    stroke: "#003E60"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.283,
    cy: 30.283,
    r: 28.783,
    transform: "matrix(-1 0 0 1 181.067 50.5337)",
    stroke: "black",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 4.23019,
    transform: "matrix(-1 0 0 1 154.015 77.5864)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M159.062 57.1959L142.709 105.043M177.636 88.8921L124.338 72.5393M135.038 59.6185L168.349 103.832M174.809 68.5015L125.953 93.5355M145.939 55.3789L156.236 106.86M168.753 60.0223L132.615 102.015M123.934 83.2393L179.049 77.9902",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.717 79.2011L151.189 78.3936L151.391 83.2388L100.313 93.9388",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.956 81.2201L103.139 84.6522L103.947 86.0654L107.984 86.873L107.581 88.69L103.745 87.8824L102.735 89.2956L102.937 92.9296H101.12V89.6994L98.6976 88.8918L95.8712 90.305L95.2655 88.69L98.0919 87.2767L98.2938 85.6617L95.6693 83.0371L96.6787 81.6239L99.707 84.2484L101.322 83.8447L103.139 80.4126L104.956 81.2201Z",
    fill: "black",
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.27736,
    cy: 8.27736,
    r: 6.77736,
    transform: "matrix(-1 0 0 1 109.6 78.3936)",
    stroke: "black",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 3.23019,
    transform: "matrix(-1 0 0 1 104.351 83.6426)",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2657 101.61L101.322 89.0935L102.13 86.6708L100.313 85.8633L98.4959 88.6897L92.6412 101.61H90.0167V103.629L91.0261 105.043H96.8808L98.0921 104.033V101.61H95.2657Z",
    fill: "black",
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.81698,
    cy: 1.81698,
    r: 1.81698,
    transform: "matrix(-1 0 0 1 55.4951 4.09961)",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138.625 20.875H166.75V32.125H138.625V20.875Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.625 15.25C137.133 15.25 135.702 15.8426 134.648 16.8975C133.593 17.9524 133 19.3832 133 20.875V32.125C133 33.6168 133.593 35.0476 134.648 36.1025C135.702 37.1574 137.133 37.75 138.625 37.75H166.75C168.242 37.75 169.673 37.1574 170.727 36.1025C171.782 35.0476 172.375 33.6168 172.375 32.125V20.875C172.375 19.3832 171.782 17.9524 170.727 16.8975C169.673 15.8426 168.242 15.25 166.75 15.25H138.625ZM166.75 18.0625C167.496 18.0625 168.211 18.3588 168.739 18.8863C169.266 19.4137 169.562 20.1291 169.562 20.875V32.125C169.562 32.8709 169.266 33.5863 168.739 34.1137C168.211 34.6412 167.496 34.9375 166.75 34.9375H138.625C137.879 34.9375 137.164 34.6412 136.636 34.1137C136.109 33.5863 135.812 32.8709 135.812 32.125V20.875C135.812 20.1291 136.109 19.4137 136.636 18.8863C137.164 18.3588 137.879 18.0625 138.625 18.0625H166.75ZM178 26.5C178 27.6189 177.556 28.6919 176.764 29.4831C175.973 30.2743 174.9 30.7188 173.781 30.7188V22.2812C174.9 22.2812 175.973 22.7257 176.764 23.5169C177.556 24.3081 178 25.3811 178 26.5Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_49919",
    x: 0,
    y: 0,
    width: 190.579,
    height: 125.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_49919"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_49919",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat100);
export default __webpack_public_path__ + "static/media/bat_100.be2beaf22074d500d457822056651951.svg";
export { ForwardRef as ReactComponent };